import { createContext } from "react";

export type SnackSurface = "mobile";

const SnackSurfaceContext = createContext<SnackSurface | undefined>(undefined);

export default SnackSurfaceContext;
